import React__default from 'react';
import styled from 'styled-components';
import { themeGet } from '../../utils/theme-get.js';
import Spacer from '../Spacer/Spacer.js';
import Box from '../Box/Box.js';
import Text from '../Text/Text.js';
import Heading from '../Heading/Heading.js';

/**
 *
 * Use a Centered Section Header for call out text and to create architectural rhythm in your Getting Started Page layouts.
 *
 */
const CenteredSectionHeader = ({
  heading,
  subtitle,
  description,
  variant = 'ThreeLine'
}) => {
  let Component;
  if (variant === 'TwoLine') {
    Component = TwoLine;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  } else if (variant === 'ThreeLine') {
    Component = ThreeLine;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  } else {
    throw new Error(`Unrecognized CenteredSectionHeader variant: ${variant}`);
  }
  return /*#__PURE__*/React__default.createElement(Component, {
    heading: heading,
    subtitle: subtitle,
    description: description
  });
};
CenteredSectionHeader.displayName = "CenteredSectionHeader";
const ThreeLine = ({
  heading,
  subtitle,
  description
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(StyledSmallHeading, {
    as: "h2"
  }, heading), /*#__PURE__*/React__default.createElement(Subtitle, {
    as: "p"
  }, subtitle), /*#__PURE__*/React__default.createElement(Spacer, {
    axis: "vertical",
    size: 8
  }), /*#__PURE__*/React__default.createElement(DescriptionWrapper, null, /*#__PURE__*/React__default.createElement(Description, {
    as: "p"
  }, description)));
};
ThreeLine.displayName = "ThreeLine";
const TwoLine = ({
  heading,
  subtitle,
  description
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(StyledHeading, {
    variant: "h700",
    as: "h2"
  }, heading), /*#__PURE__*/React__default.createElement(DescriptionWrapper, {
    sx: {
      mt: 4
    }
  }, /*#__PURE__*/React__default.createElement(Description, {
    as: "p"
  }, description)));
};
TwoLine.displayName = "TwoLine";
const Wrapper = styled(Box).withConfig({
  displayName: "CenteredSectionHeader__Wrapper",
  componentId: "sc-kjv9gx-0"
})(["text-align:center;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], themeGet('breakpoints.0'), themeGet('breakpoints.1'), themeGet('breakpoints.2'));
const StyledSmallHeading = styled(Text).withConfig({
  displayName: "CenteredSectionHeader__StyledSmallHeading",
  componentId: "sc-kjv9gx-1"
})(["font-size:", ";color:", ";font-weight:", ";letter-spacing:0.025em;text-transform:uppercase;"], themeGet('fontSizes.3'), themeGet('colors.text.accent.blue.default'), themeGet('fontWeights.medium'));
const StyledHeading = styled(Heading).withConfig({
  displayName: "CenteredSectionHeader__StyledHeading",
  componentId: "sc-kjv9gx-2"
})(["font-weight:", ";"], themeGet('fontWeights.semibold'));
const Subtitle = styled(Text).withConfig({
  displayName: "CenteredSectionHeader__Subtitle",
  componentId: "sc-kjv9gx-3"
})(["margin-top:", ";font-size:", ";font-weight:700;letter-spacing:-0.025em;color:", ";@media (min-width:350px){font-size:", ";}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], themeGet('space.0'), themeGet('fontSizes.6'), themeGet('colors.text.default'), themeGet('fontSizes.7'), themeGet('breakpoints.0'), themeGet('breakpoints.1'), themeGet('breakpoints.2'));
const DescriptionWrapper = styled(Box).withConfig({
  displayName: "CenteredSectionHeader__DescriptionWrapper",
  componentId: "sc-kjv9gx-4"
})(["margin:0 auto;margin-top:", ";@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){max-width:80ch;}"], themeGet('space.2'), themeGet('breakpoints.0'), themeGet('breakpoints.1'), themeGet('breakpoints.2'));
const Description = styled(Text).withConfig({
  displayName: "CenteredSectionHeader__Description",
  componentId: "sc-kjv9gx-5"
})(["color:", ";font-size:", ";margin:0 auto;@media (min-width:350px){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], themeGet('colors.text.subtle'), themeGet('fontSizes.4'), themeGet('breakpoints.0'), themeGet('breakpoints.1'), themeGet('breakpoints.2'));
CenteredSectionHeader.displayName = 'CenteredSectionHeader';
var CenteredSectionHeader$1 = CenteredSectionHeader;

export { CenteredSectionHeader$1 as default };
